import isEmpty from 'lodash/isEmpty'
import React from "react";
import {useTranslation} from "react-i18next";

import {Button, ButtonGroup, Col, Row} from 'reactstrap'


function DefaultArrayItem(props) {
    return (
        <Col key={props.index} className={props.className} xs={12}>
            <Row>
                <Col xs={props.hasToolbar ? 9 : 12} className='array-element-fields'>
                    {props.children}
                </Col>

                {props.hasToolbar && (
                    <Col xs={3} className="d-flex align-items-center array-element-buttons">
                        <ButtonGroup className='w-100 mt-3'>
                            {(props.hasMoveUp || props.hasMoveDown) && (
                                <Button
                                    color='light'
                                    disabled={props.disabled || props.readonly || !props.hasMoveUp}
                                    onClick={props.onReorderClick(props.index, props.index - 1)}
                                >
                                    <i className='lnr-arrow-up'></i>
                                </Button>
                            )}

                            {(props.hasMoveUp || props.hasMoveDown) && (
                                <Button
                                    color='light'
                                    disabled={
                                        props.disabled || props.readonly || !props.hasMoveDown
                                    }
                                    onClick={props.onReorderClick(props.index, props.index + 1)}
                                >
                                    <i className='lnr-arrow-down'></i>
                                </Button>
                            )}

                            {props.hasRemove && (
                                <Button
                                    color="danger"
                                    disabled={props.disabled || props.readonly}
                                    onClick={props.onDropIndexClick(props.index)}
                                >
                                    <i className='lnr-trash'></i>
                                </Button>
                            )}
                        </ButtonGroup>
                    </Col>
                )}
            </Row>
        </Col>
    );
}

const DefaultNormalArrayFieldTemplate = (props) => {
    const {t, i18n} = useTranslation();
  
    return (
        <fieldset className={`${props.className} ${props.uiSchema.className}`} id={props.idSchema.$id}>
            <Row key={`array-item-list-${props.idSchema.$id}`}>
                {props.items && props.items.map(p => DefaultArrayItem(p))}
            </Row>

            {props.canAdd && <Button
                    onClick={props.onAddClick}
                    disabled={props.disabled || props.readonly}
                    className={'btn-light ' + (isEmpty(props.items) ? 'mt-1' : '')}
                    size='lg'
                >
                    {t('components.api_form.button.add', 'Add')}
                </Button>
            }
        </fieldset>
    );
};

export default DefaultNormalArrayFieldTemplate;
